import { Flame, Handshake, Search } from "lucide-react";

export const pillars = [
  {
    id: "process-improvements",
    title: "Welding & Process Improvements",
    tagline: "Cleaner, safer, more efficient operations.",
    icon: Flame,
    image: "https://images.pexels.com/photos/37517098/pexels-photo-37517098.jpeg?auto=compress&cs=tinysrgb&w=2000",
    description:
      "Helping shops and facilities improve how work gets done — from automating repetitive welds to cleaning up the air and the finished product.",
    items: [
      "Welding automation",
      "Fume extraction systems",
      "Post-weld cleaning",
    ],
  },
  {
    id: "equipment-brokerage",
    title: "Equipment Sales & Project Development",
    tagline: "Connecting buyers and sellers of capital equipment.",
    icon: Handshake,
    image: "https://images.unsplash.com/photo-1496247749665-49cf5b1022e9",
    description:
      "Matching the right capital equipment with the right operation — whether you're acquiring, upgrading, or moving assets on.",
    items: [
      "Capital equipment",
      "Lasers",
      "Cutting & bending equipment",
      "Press brakes",
    ],
  },
  {
    id: "product-sourcing",
    title: "Specialized Industrial Sourcing",
    tagline: "Finding the hard-to-find.",
    icon: Search,
    image: "https://images.unsplash.com/photo-1565891741441-64926e441838",
    description:
      "Tracking down niche, specialty, and hard-to-find industrial products — the items that fall outside day-to-day purchasing cycles.",
    items: [
      "Hard-to-find products",
      "Niche & specialty markets",
      "Off-cycle & non-standard sourcing",
    ],
  },
];
